import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useAppContext } from '@overrides_venia/peregrine/context/app';
import { gql } from "@apollo/client";
export const GET_STORE_CONFIG = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query getStoreConfigs {\n        storeConfig {\n            store_code\n            default_display_currency_code\n        }\n    }\n"])));
export const currencyList = [{
  code: "EUR",
  symbol: "€"
}, {
  code: "CHF",
  symbol: "CHF"
}];
export function useMagentoConfig() {
  const [{
    magentoConfig
  }, {
    actions: {
      setMagentoConfig
    }
  }] = useAppContext();
  const [getMagentoConfig, {
    data,
    loading
  }] = useLazyQuery(GET_STORE_CONFIG, {
    fetchPolicy: "network-only",
    onCompleted: data => {
      var _currencyList$find;
      const currencySymbol = (_currencyList$find = currencyList.find(currency => currency.code === data.storeConfig.default_display_currency_code)) === null || _currencyList$find === void 0 ? void 0 : _currencyList$find.symbol;
      const config = _objectSpread(_objectSpread({}, data.storeConfig), {}, {
        currency_symbol: currencySymbol
      });
      setMagentoConfig(config);
    }
  });
  useEffect(() => {
    if (!magentoConfig) {
      getMagentoConfig();
    }
  }, []);

  //return currency symbol and currency code if magentoConfig has value otherwise return defaults
  return {
    currencySymbol: (magentoConfig === null || magentoConfig === void 0 ? void 0 : magentoConfig.currency_symbol) || "€",
    currencyCode: (magentoConfig === null || magentoConfig === void 0 ? void 0 : magentoConfig.default_display_currency_code) || "EUR"
  };
}
;